export default "/images/doge__qr_code.png";